import styled from "styled-components";
import { QUERY_IPHONE_6_7_8_PLUS, PRIMARY_COLOR } from "@shared/constants";

export const StyledHeadline = styled.h2`
  display: flex;
  font-size: 32px;
  margin-bottom: 48px;
  align-items: center;

  &::after {
    content: "";
    display: block;
    margin-left: 24px;
    width: 214px;
    height: 1px;
    background-color: ${`${PRIMARY_COLOR}5e`};
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    font-size: 28px;

    &::after {
      left: 107%;
      width: 50px;
    }
  }
`;
